const normalizeDayOrMonth = (value: number): string | number => (
  value < 10 ? `0${value}` : value
);

const dateToString = (date: Date): string => {
  if (date == null) {
    return null;
  }
  const day = normalizeDayOrMonth(date.getDate());
  const month = normalizeDayOrMonth(date.getMonth() + 1);
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};

export default dateToString;
